import React from 'react';
import Logo_Auckland from './Logo_Auckland2.jpg';
import Seb_Wagner from './Seb_Wagner.jpeg';
import Send_Mail from './send-mail.png';
import './App.css';
import ReactGA from 'react-ga';

function App() {
    ReactGA.initialize('UA-166881556-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
    console.log("inited");

    return (
    <div className="App">
        <img
            className={'imageLogo'}
            src={Logo_Auckland} alt={'Arrakee Solutions Auckland'}></img>
        <h2>Arrakeen Solutions</h2>
        <p className={'centeredBlock'}>Software Solutions and Consulting</p>
        <h4>OpenMeetings Consulting</h4>
        <p className={'centeredBlock'}>We provide consulting, installation, customisation, styling or custom module development for <a href={'https://openmeetings.apache.org'} target={'_BLANK'}>Apache OpenMeetings</a></p>
        <p><a href={'mailto:sales@arrakeen-solutions.co.nz'}>
            <img
                className={'sendEmailIcon'}
                src={Send_Mail} alt={'Send Email to Sales'}></img>
            Email Sales</a></p>
        <h4>Who we are</h4>
        <img className={'imagePhoto'}
             src={Seb_Wagner} alt={'Seb'}></img>

        <p className={'centeredBlock'}><b>Sebastian Wagner</b> - Director Arrakeen Solutions, Solutions Architect & Tech Lead, Founder & Former Chair Apache OpenMeetings, <a href={'https://www.linkedin.com/in/sebastianwagner/'} target={'_BLANK'}>Contact and full bio</a></p>
        <p><a href={'mailto:sales@arrakeen-solutions.co.nz'}>
            Contact us
        </a></p>
        <p>© 2020 Arrakeen Solutions Limited</p>
    </div>
  );
}

export default App;
